var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._b({attrs:{"validate-on-blur":"","items":_vm.carriers,"cache-items":"","label":_vm.label,"item-value":"ID","item-text":"CarrierName","rules":_vm.rules || [_vm.form_rules.required],"loading":_vm.isLoading,"clearable":_vm.clearable,"return-object":_vm.returnObject,"multiple":_vm.isMultiple()},model:{value:(_vm.CarrierIDs),callback:function ($$v) {_vm.CarrierIDs=$$v},expression:"CarrierIDs"}},'v-autocomplete',{
				..._vm.$attrs,
				...(_vm.appendIcon !== undefined && { appendIcon: _vm.appendIcon })
			},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }